const VALIDATION_SEVERITIES = ["error", "warning", "info"];

export const VALIDATION_SEVERITY_RANK = Object.freeze({
  error: 0,
  warning: 1,
  info: 2,
});

function normalizeText(value) {
  return typeof value === "string" ? value.trim() : "";
}

function normalizeMetadata(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return null;
  }

  return value;
}

export function normalizeValidationSeverity(value) {
  const normalized = normalizeText(value).toLowerCase();
  return VALIDATION_SEVERITIES.includes(normalized) ? normalized : "info";
}

export function isBlockingValidationSeverity(value) {
  return normalizeValidationSeverity(value) === "error";
}

export function createValidationIssue({
  blocking,
  code = "validation.issue",
  field = "",
  message = "",
  metadata = null,
  scope = "",
  severity = "info",
  source = "",
} = {}) {
  const normalizedSeverity = normalizeValidationSeverity(severity);

  return {
    blocking: typeof blocking === "boolean"
      ? blocking
      : isBlockingValidationSeverity(normalizedSeverity),
    code: normalizeText(code) || "validation.issue",
    field: normalizeText(field),
    message: normalizeText(message) || "Validation issue",
    metadata: normalizeMetadata(metadata),
    scope: normalizeText(scope),
    severity: normalizedSeverity,
    source: normalizeText(source),
  };
}